import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import MiWriteLogo from "../../assets/MiWriteLogo";
import UtahComposeLogo from "./UtahComposeLogo";

export default function PublicHeader() {
	const { config } = useAppSelector((state) => state.site);
	let location = useLocation();

	function LoginButton() {
		if (location.pathname === "/") {
			return null;
		}
		return (
			<Link to="/login" className="btn btn-primary">
				Login
			</Link>
		);
	}

	return (
		<header className="bg-primary-700">
			<div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
				<div className="relative flex items-center py-3 justify-between">
					{config?.isUtahComposeSite ? (
						<UtahComposeLogo />
					) : (
						<MiWriteLogo className="h-12 text-white" />
					)}
					<LoginButton />
				</div>
			</div>
		</header>
	);
}
